import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import {Lang} from '../api/lang';
import { getInitialLang, getStoredLang, setStoredLang } from '../api/langStorage';
import { genlink, login } from '../api/api';
import '../App.css';
import { jwtDecode } from 'jwt-decode';
import 'bootstrap/dist/css/bootstrap.min.css';
import { getInitialRes, getStoredRes, setStoredRes } from '../api/resStorage';


function LethalBlade(){
  const [lang, setLang] = useState<string>(() => getStoredLang());
    const [resolution, setResolution] = useState<string>(() => getStoredRes());
    const [showLoginDialog, setShowLoginDialog] = useState<boolean>(false);
    const [showCreateRoomDialog, setShowCreateRoomDialog] = useState<boolean>(false);
    const [inviteCount, setInviteCount] = useState<number>(1);
    const [friendUsernames, setFriendUsernames] = useState<string[]>(["","",""]);
    const [roomUrls, setRoomUrls] = useState<string[]>([]);
    const [isPortrait, setIsPortrait] = useState(false);
    const [bgopacity, setBgopacity] = useState<number>(1);
    const [titleopacity, setTitleopacity] = useState<number>(0);
    const [dialogopacity, setDialogopacity] = useState<number>(0);
    const [loading, setLoading] = useState<boolean>(false);
    const [name, setName] = useState<string>("");
    const [email, setEmail] = useState<string>("");
    const [username, setUsername] = useState<string>("");
    const [token, setToken] = useState(() => {
      try {
        const item: string = window.localStorage.getItem("token") as string;
        if (!item) return "";
        const decodedToken: any = jwtDecode(item);
        setUsername(decodedToken.aud);
        setEmail(decodedToken.sub);
        const currentTime = Date.now() / 1000; // Convert to seconds
        return (decodedToken.exp < currentTime) ? "" : item;
      } catch (error) {
        return "";
      }
    });
    const [rotate,setRotate]=useState<number>(0);
    const [password, setPassword] = useState<string>("");
    const [error, setError] = useState<string>("");

    const fadeInTitle=()=> {
      let opacity = 0;
      let bgopacity = 1;
      let dialogopacity = 0;
      const interval = setInterval(() => {
        opacity += 0.05; // เพิ่มทีละ 0.05
        setTitleopacity(opacity);
        bgopacity -= 0.03; // ลดทีละ 0.01
        setBgopacity(bgopacity);
        dialogopacity += 0.05; // เพิ่มทีละ 0.05
        setDialogopacity(dialogopacity);
        if (opacity >= 1) {
          clearInterval(interval); // หยุดเมื่อ opacity = 1
        }
      }, 130); 
  }

  const handleLangChange = (value: string) => {
    setStoredLang(value);
    setLang(value);
  };

     const handleResChange = (value: string) => {
      setStoredRes(value);
      setResolution(value);
    };

  useEffect(() => {
    //set title
    document.body.style.backgroundColor = "black";
    setLang(getInitialLang(window.location.search));
    setResolution(getInitialRes(window.location.search));
    fadeInTitle();
    const mediaQuery = window.matchMedia("(orientation: portrait)");
    const handleOrientationChange = (e:any) => {
      setIsPortrait(e.matches);
    };
    setIsPortrait(mediaQuery.matches);
    mediaQuery.addEventListener("change", handleOrientationChange);
    //ทำ animation หมุนรอ ช้าๆ
    const interval = setInterval(() => {
        setRotate((prevRotate) => (prevRotate + 1) % 360);
    }, 100);
    return () => {
      clearInterval(interval);
      mediaQuery.removeEventListener("change", handleOrientationChange);
    };
  }, []);

  useEffect(() => {
    document.title=Lang.get(lang,"lethal_blade_title");
    document.body.style.backgroundColor = "black";
  }, [lang]);

  const handleLogin=()=> {
    //validate 
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email || !emailRegex.test(email)) {
        setLoading(false);
        setError("missing_email");
        return;
    }
    if (!password) {
        setLoading(false);
        setError("missing_password");
        return;
    }
    setLoading(true);
    setToken("");
    setError("");
    login(email,password).then((res)=>{
        const token=res.token;
        setToken(token);
        const decodedToken: any = jwtDecode(token);
        setUsername(decodedToken.aud);
        setEmail(decodedToken.sub);
        window.localStorage.setItem("token", token);
        window.localStorage.setItem("email", decodedToken.sub);
        window.localStorage.setItem("username", decodedToken.aud);
        window.localStorage.setItem("id", decodedToken.jti);
        setLoading(false);
        setShowLoginDialog(false);
    }).catch((err)=>{
        if (err.response!==undefined  && err.response.status===401) {
          setError("wrong_password");
        } else if (err.response!==undefined  && err.response.status===403) {
          setError("not_verified");
        } else {
          setError("network_error");
        }
        setLoading(false);
    });
  }

  const handlesingle=()=> {
    window.location.href="/lethalblade/single.html?name="+name+"&lang="+lang+"&res="+resolution;
  }
  
  const handlemulti=()=> {
    if (!token) {
      setShowLoginDialog(true);
      setError("");
      return;
    }
    setShowCreateRoomDialog(true);
    setRoomUrls([]);  //clear
    setFriendUsernames(["","",""]);
  }

  const handleonline=()=> {
    if (!token) {
      setShowLoginDialog(true);
      setError("");
      return;
    }
    //จะต้องไป list ห้องมาก่อน และเลือกห้องที่จะ join
    window.location.href="/lethalblade/multi.html?token="+token+"&room=world"+"&lang="+lang+"&res=high";
  }


  const isMobile = () => {
    return window.innerWidth <= 480;
  };

  const openLoginDialog = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    setShowLoginDialog(true);
    setError("");
  };

  const closeLoginDialog = () => {
    setShowLoginDialog(false);
    setLoading(false);
  };

  const closeCreateRoomDialog = () => {
    setShowCreateRoomDialog(false);
  };

  const updateFriendUsername = (index: number, value: string) => {
    const newNames = [...friendUsernames];
    newNames[index] = value;
    setFriendUsernames(newNames);
  };

  const createlink = (name: string, no: string): Promise<string> => {
      return new Promise<string>((resolve, reject) => {    
        genlink(name,no,token)
        .then(data => {
          const roomToken = data.token;
          resolve(roomToken);
        }).catch((err)=>{
          if (err.response!==undefined  && err.response.status===401) {
            setError("wrong_password");
          } else if (err.response!==undefined  && err.response.status===403) {
            setError("not_verified");
          } else {
            setError("network_error");
          }
          reject(err);
        });
      });
  }
  
  const getRoomName = (): string => {
      //ดึงจาก token โดยเอา . มาแยก แล้วเอาส่วนสุดท้ายเป็นชื่อห้อง
    	const signature = token.split('.').pop() || '';
      return signature;
  }

  const generateRoomUrls = async () => {
    //เช็คว่า เพื่อนที่กรอกมาครบหรือไม่
    setError("");
    for (let i = 0; i < inviteCount; i++) {
      if (!friendUsernames[i] || friendUsernames[i].trim() === "") {
        setError(`${Lang.get(lang,"missing_friend_name")} ${i + 1}`);
        return;
      }
    }
    const friendToken: string[]=[];
    for (let i = 0; i < inviteCount; i++) {
      const t = await createlink(friendUsernames[i], (i+1).toString());
      friendToken.push(t);
    }
    const roomName=getRoomName();
    const urls = Array.from({ length: inviteCount }, (_, index) => {
      const baseUrl = `${window.location.origin}/lethalblade/multi.html?lang=${lang}&res=high&token=${friendToken[index]}&room=${roomName}`;
      return baseUrl;
    });
    setRoomUrls(urls);
  };

  const startRoom = () => {
    //ไม่ต้องบอกชื่อห้อง มันจะใช้จาก signature ใน token แทน
    const roomName=getRoomName();
    window.location.href="/lethalblade/multi.html?lang="+lang+"&res=high&token="+token+"&room="+roomName;
  };
  
  return (<>
      <div className="c" style={{width:"100%",paddingRight:"10px",paddingTop:"10px",overflowX: "hidden",position: "absolute",zIndex: 9999}}>
        <table><tbody><tr>
        <td width="80%"></td>
        <td width="220px" style={{textAlign: "right",whiteSpace: "nowrap"}}>
          {Lang.get(lang,"bandwidth")}&nbsp;&nbsp;
        </td>
        <td width="80px">
        <select value={resolution} className="form-select form-select-sm form-control-sm" onChange={e=>{handleResChange(e.currentTarget.value)}} style={{width:"70px"}}>
          <option value="low" >{Lang.get(lang,"low")}</option>
          <option value="high" >{Lang.get(lang,"high")}</option>
        </select>
        </td>
        <td width="80px">
        <select value={lang} className="form-select form-select-sm form-control-sm" onChange={e=>{handleLangChange(e.currentTarget.value)}} style={{width:"70px"}}>
          <option value="th">ไทย</option>
          <option value="en">Eng</option>
        </select>
        </td>
        </tr></tbody></table>
      </div>

      <div className="c" style={{width:"100%",paddingRight:"10px",paddingTop:"10px",overflowX: "hidden",position: "absolute",zIndex: 9000}}>
            <div className="flex flex-wrap gap-1 menulink">
            <img src="/img/capture.png" alt="New Games" className="w-1 logo_main"/>
            { isMobile() &&
              <br/>
            }
              {token && (
                <>
                  <a href="/logout" className="rounded-full bg-cyan-500 px-1 py-1 text-sm font-semibold text-slate-950 transition hover:bg-cyan-400" onClick={() => {
                    setToken("");
                    window.localStorage.removeItem("token");
                  }}>
                    {Lang.get(lang,"logout")}
                  </a>
                  <a href="/changepassword" className="rounded-full bg-cyan-500 px-1 py-1 text-sm font-semibold text-slate-950 transition hover:bg-cyan-400">
                    {Lang.get(lang,"change_password")}
                  </a>
                  <span className="px-1 py-1 text-sm font-semibold"> {Lang.get(lang,"welcome")}:&nbsp;&nbsp;{username}</span>
                </>
              )}
              { !token && (
                <>
              <a href="/login" className="rounded-full bg-cyan-500 px-3 py-1 text-sm font-semibold text-slate-950 transition hover:bg-cyan-400 " onClick={openLoginDialog}>
                {Lang.get(lang,"login")}
              </a>
              <a href="/signup" className="rounded-full bg-cyan-500 px-3 py-1 text-sm font-semibold text-slate-950 transition hover:bg-cyan-400">
                {Lang.get(lang,"signup")}
                </a>
            <a href="/resetpassword" className="rounded-full bg-cyan-500 px-3 py-1 text-sm font-semibold text-slate-950 transition hover:bg-cyan-400">
              {Lang.get(lang,"forget_password")}
            </a>
              </>)
                }
      
            </div>
        </div>

      <div id="bg" className="bg c" style={{justifyContent: "center", textAlign: "center",display:"block",opacity: bgopacity, backgroundImage: "url(lethalblade/assets/"+resolution+"/bg"+(isPortrait?"v":"")+".jpg)"}}>
        &nbsp;
      </div>
      <div className="title c" style={{top:80,left: "50%",transform: "translate(-50%, 0)",position: "absolute",zIndex: 9999,opacity: titleopacity}}>
          <img  src={"lethalblade/assets/"+resolution+"/title.png"} style={{width:"100%"}} alt={"Props"}/>
      </div>
      

      <div className="row" style={{position: "absolute",zIndex: 8888,top: 0, left:0, width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center"}}>
        <div className="col-md-12">
          <div className="c" style={{top:50,left: "50%",transform: "translate(-50%, 0)",marginLeft:"10px",width: "400px",position: "relative",zIndex: 9999,display: "block",textAlign: "center",justifyContent: "center",opacity: dialogopacity}}>
                <img src={"img/header.png"} alt="header" style={{width:"300px",height:"80px", transform: "scaleY(-1)"}}/><br/>
                <div className="buttonup"  style={{cursor: "pointer",position:"relative"}} onClick={handlesingle}>
                  <img src={"img/buttons.png"} alt="click"/>
                  <div style={{position: "absolute",marginTop: "-5px",marginLeft:"-2px",top:"50%",left: "50%",transform: "translate(-50%, -50%)"}}>
                    { Lang.get(lang,"singlemode")}
                  </div>
                </div>
                <div className="buttonup"  style={{cursor: "pointer",position:"relative"}} onClick={handlemulti}>
                  <img src={"img/buttons.png"} alt="click"/>
                  <div style={{position: "absolute",marginTop: "-5px",marginLeft:"-2px",top:"50%",left: "50%",transform: "translate(-50%, -50%)"}}>
                    { Lang.get(lang,"multimode")}
                  </div>
                </div>
                <div className="buttonup"  style={{cursor: "pointer",position:"relative"}} onClick={handleonline}>
                  <img src={"img/buttons.png"} alt="click"/>
                  <div style={{position: "absolute",marginTop: "-5px",marginLeft:"-2px",top:"50%",left: "50%",transform: "translate(-50%, -50%)"}}>
                    { Lang.get(lang,"onlinemode")}
                  </div>
                </div>
                <span className="foot">{ Lang.get(lang,"play_free")}!</span><br/>
                <img src={"img/header.png"} alt="header" style={{width:"300px",height:"80px",marginTop:"-20px"}}/>
          </div>
          <div style={{height:"50px"}}>&nbsp;</div>
        </div>
      </div>
      <div className="c" style={{position: "absolute",left: "50%",transform: "translate(-50%, 0)",marginLeft:"0px",bottom:"0px",zIndex: 999,whiteSpace: "nowrap"}}>
        { Lang.get(lang,"copyright_title")} { Lang.get(lang,"all_right_reserve_title")}
      </div>

      {showLoginDialog && (
        <div className="c" style={{position:"absolute", left:"50%",top:"50%", transform:"translate(-50%, -50%)", zIndex: 9999}}>
          <div style={{ backgroundColor: '#223a44', borderRadius: '20px', padding: '20px', width: '350px', boxShadow: '0 4px 12px rgba(0, 0, 0, 0.5)' }}>
            <div className="mb-4 flex items-center justify-between">
              <h4 className="text-md font-semibold">{Lang.get(lang, "login")}</h4>
              <button className="text-slate-300 hover:text-white" onClick={closeLoginDialog} style={{position: "absolute", top: "10px", right: "10px", fontSize: "18px"}}>
                ×
              </button>
            </div>
            <div className="space-y-4 text-center">
              <div>
                <label className="mb-2 block text-sm text-slate-200">{Lang.get(lang, "email")}</label><br/>
                <input
                  type="text"
                  className="w-full rounded-lg border border-slate-600 bg-slate-900 px-3 py-2 text-black outline-none focus:border-cyan-500"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  disabled={loading}
                />
              </div>
              <div>
                <label className="mb-2 block text-sm text-slate-200">{Lang.get(lang, "password")}</label><br/>
                <input
                  type="password"
                  className="w-full rounded-lg border border-slate-600 bg-slate-900 px-3 py-2 text-black outline-none focus:border-cyan-500"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  disabled={loading}
                />
              </div>
              {error && (
                <div className="rounded-lg bg-red-600/20 px-3 py-2 text-sm text-red-100">
                  {Lang.get(lang, error) || 'Error'}
                </div>
              )}
              <br/>
              <div className="flex items-center justify-end gap-3">                
                <button
                  className="rounded-full bg-cyan-500 px-4 py-2 text-sm font-semibold text-slate-950 hover:bg-cyan-400"
                  onClick={handleLogin}
                  disabled={loading}
                  style={{width: "150px"}}
                >
                  {loading ? Lang.get(lang, "loading") || 'Loading...' : Lang.get(lang, "login")}
                </button>&nbsp;&nbsp;
                <button
                  className="rounded-full bg-slate-700 px-4 py-2 text-sm font-semibold text-slate-300 hover:bg-slate-600"
                  onClick={closeLoginDialog}
                  disabled={loading}
                  style={{width: "150px"}}
                >
                  {Lang.get(lang, "cancel_title") || 'Cancel'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

       {showCreateRoomDialog && (
        <div style={{position: "fixed", inset: 0, zIndex: 10000, backgroundColor: "rgba(0,0,0,0.6)", display: "flex", alignItems: "center", justifyContent: "center", padding: "20px"}}>
          <div style={{backgroundColor: '#0f172a', borderRadius: '18px', width: 'min(420px, 100%)', padding: '24px', boxShadow: '0 10px 30px rgba(0,0,0,0.5)', color: '#e2e8f0'}}>
            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '18px'}}>
              <h3 style={{margin: 0, fontSize: '1.15rem'}}>{Lang.get(lang, "multimode")}</h3>
              <button onClick={closeCreateRoomDialog} style={{background: 'transparent', border: 'none', color: '#cbd5e1', fontSize: '1.4rem', cursor: 'pointer'}}>×</button>
            </div>

            <div style={{display: 'grid', gap: '14px'}}>
              { roomUrls.length === 0 && (
                <>
              <div>
                <label style={{display: 'block', marginBottom: '6px', color: '#cbd5e1'}}>{Lang.get(lang, "invite_friends_count")}</label>
                <select value={inviteCount} onChange={(e) => setInviteCount(Number(e.target.value))} style={{width: '100%', borderRadius: '12px', padding: '10px', backgroundColor: '#14213d', border: '1px solid #334155', color: '#f8fafc'}}>
                  <option value={1}>1</option>
                  <option value={2}>2</option>
                  <option value={3}>3</option>
                </select>
              </div>

              {Array.from({ length: inviteCount }, (_, index) => (
                <div key={index}>
                  <label style={{display: 'block', marginBottom: '6px', color: '#cbd5e1'}}>{Lang.get(lang, "friend_name")} {index + 1}</label>
                  <input
                    type="text"
                    value={friendUsernames[index]}
                    onChange={(e) => updateFriendUsername(index, e.target.value)}
                    placeholder={`${Lang.get(lang, "friend_name")} ${index + 1}`}
                    style={{width: '100%', borderRadius: '12px', padding: '10px', backgroundColor: '#14213d', border: '1px solid #334155', color: '#f8fafc'}}
                  />
                </div>
              ))}

              <button onClick={generateRoomUrls} style={{borderRadius: '999px', padding: '12px 18px', backgroundColor: '#06b6d4', color: '#0f172a', fontWeight: 700, border: 'none', cursor: 'pointer'}}>
                { Lang.get(lang, "ok_title") } 
              </button>
              </>)}

              {roomUrls.length > 0 && (
                <>
                <div style={{backgroundColor: '#020617', borderRadius: '14px', padding: '14px', border: '1px solid #334155'}}>
                  <div style={{marginBottom: '10px', color: '#cbd5e1', fontWeight: 600}}>ส่ง URL ให้เพื่อน</div>
                  {roomUrls.map((url, idx) => (
                    <div key={idx} style={{marginBottom: '10px'}}>
                      <div style={{fontSize: '0.85rem', color: '#94a3b8', marginBottom: '4px'}}>ลิงก์ {idx + 1}</div>
                      <input
                        readOnly
                        value={url}
                        onFocus={(e) => e.target.select()}
                        style={{width: '100%', borderRadius: '10px', padding: '10px', backgroundColor: '#0f172a', border: '1px solid #334155', color: '#f8fafc'}}
                      />
                    </div>
                  ))}
                </div>
                <button onClick={startRoom} style={{borderRadius: '999px', padding: '12px 18px', backgroundColor: '#06b6d4', color: '#0f172a', fontWeight: 700, border: 'none', cursor: 'pointer'}}>
                { Lang.get(lang, "ok_title") } 
              </button>
              </>
              )}
            </div>
            {error && (
              <div style={{marginTop: '10px', color: 'red'}}>{error}</div>
            )}
          </div>
        </div>
       )}
      </>);
}

export default LethalBlade;


